export const post_procedureSos = `
mutation PostProcedureSos($tenantId: String!, $aziendaId: Int!, $dataInput: ProceduraSosInput!) {
    postProceduraSos(tenantId: $tenantId, aziendaId: $aziendaId, dataInput: $dataInput) {
        id
        aziendaId   
        nominativoReferenteSos     
        contributoColleghi
        attivitaStrumentiAnomalie
        prioritaAnomalie
        strumentiSelezione
        partenariati
        soggettiEsterni
        createdOn
        modifiedOn
        createdBy
        modifiedBy
    }
}`;
export const delete_procedureSos = `
mutation DeleteProcedureSos($tenantId: String!, $aziendaId: Int!) {
    deleteProceduraSos(tenantId: $tenantId, aziendaId: $aziendaId) {  
        success
        message      
    }
}`;